import { IConfig } from '../interfaces/IConfig'
import { getDomainConfig } from '../lib/utilsConfig'

const config: IConfig = {
  domain: getDomainConfig(),
}

export { config }
